<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">
            {{ this.currentView }}
          </h2>
          <div class="section__buttons">
            <button
              class="btn add"
              data-bs-toggle="modal"
              data-bs-target="#addInfoGraph"
            >
              <i class="fas fa-plus ms-1"></i>
              إضافة صورة جديد
            </button>

            <!-- Add Modal Start -->
            <div
              class="modal fade"
              id="addInfoGraph"
              tabindex="-1"
              aria-labelledby="addInfoGraphLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">أضافة صورة</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      @click="this.clearData()"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <form
                      id="addInfograph"
                      @submit.prevent="addNewInfograph($event)"
                    >
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label for="infographTitle">العنوان</label>
                            <input
                              type="text"
                              class="form-control mt-2"
                              id="infographTitle"
                              placeholder="العنوان"
                              v-model="infograph.title"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label for="infographStatus">حالة الصورة</label>
                            <select
                              class="form-select form-control mt-2"
                              aria-label="Default select "
                              v-model="infograph.status"
                            >
                              <option selected disabled value="">
                                اختار حالة الصورة
                              </option>
                              <option :value="0">حفظ داخل مسودة</option>
                              <option :value="1">نشر</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group files">
                            <label for="addressTitle">الصورة التوضيحية</label>
                            <!-- Custom Input File -->
                            <div
                              class="dragDrop"
                              @dragover="onDropOver($event)"
                              @dragleave="onDropLeave($event)"
                            >
                              <div
                                v-if="this.file == null"
                                class="dragDrop__input"
                              >
                                <div class="dragDrop__input__icon">
                                  <i
                                    class="fa fa-upload icon"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              </div>
                              <div v-else class="dragDrop__file">
                                <div class="dragDrop__file__icon">
                                  <i
                                    class="fa fa-file icon"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <div class="dragDrop__file__text">
                                  <span>{{ this.file.name }}</span>
                                </div>
                              </div>
                              <input
                                type="file"
                                id="chooseFiles"
                                placeholder="أضف الملف"
                                @change="onFileSelect($event)"
                                ref="reviewFileInput"
                                required
                              />
                            </div>
                            <!-- Custom Input File -->
                          </div>
                        </div>
                        <!-- Add Categories Select -->
                        <div class="categories__select">
                          <div
                            class="categories__select__data"
                            v-show="this.categories.length > 0"
                          >
                            <div class="row">
                              <div class="col-6">
                                <div class="form-group">
                                  <label>التصنيف</label>
                                  <select
                                    class="form-select form-control mt-2"
                                    aria-label="Default select "
                                    id="categorySelect"
                                    @change="onSelectMainCategory($event)"
                                    required
                                  >
                                    <option selected disabled :value="0">
                                      اختار التصنيف
                                    </option>
                                    <option
                                      v-for="category in this.Maincategories"
                                      :key="category.category_id"
                                      :value="category.title"
                                    >
                                      {{ category.title }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-6">
                                <Transition name="scale" mode="out-in">
                                  <div
                                    class="form-group"
                                    v-if="this.subSelect.length > 0"
                                  >
                                    <label>تصنيف فرعى</label>
                                    <select
                                      class="form-select form-control mt-2"
                                      id="subCategory"
                                      aria-label="Default select "
                                      @change="onSelectSubCategory($event)"
                                    >
                                      <option selected disabled value="">
                                        اختار التصنيف
                                      </option>
                                      <option
                                        v-for="category in this.subSelect"
                                        :key="category.category_id"
                                        :value="category.title"
                                      >
                                        {{ category.title }}
                                      </option>
                                    </select>
                                  </div>
                                </Transition>
                              </div>
                              <div class="col-6">
                                <Transition name="scale" mode="out-in">
                                  <div
                                    class="form-group"
                                    v-if="this.subSubSelect.length > 0"
                                  >
                                    <label>تصنيف فرعى</label>
                                    <select
                                      class="form-select form-control mt-2"
                                      aria-label="Default select "
                                      @change="onSelectSubSubCategory($event)"
                                    >
                                      <option selected disabled value="">
                                        اختار التصنيف
                                      </option>
                                      <option
                                        v-for="category in this.subSubSelect"
                                        :key="category.category_id"
                                        :value="category.title"
                                      >
                                        {{ category.title }}
                                      </option>
                                    </select>
                                  </div>
                                </Transition>
                              </div>
                              <div class="col-6">
                                <Transition name="scale" mode="out-in">
                                  <div
                                    class="form-group"
                                    v-if="this.subSubSubSelect.length > 0"
                                  >
                                    <label>تصنيف فرعى</label>
                                    <select
                                      class="form-select form-control mt-2"
                                      aria-label="Default select "
                                      @change="
                                        onSelectSubSubSubCategory($event)
                                      "
                                    >
                                      <option selected disabled value="">
                                        اختار التصنيف
                                      </option>
                                      <option
                                        v-for="category in this.subSubSubSelect"
                                        :key="category.category_id"
                                        :value="category.title"
                                      >
                                        {{ category.title }}
                                      </option>
                                    </select>
                                  </div>
                                </Transition>
                              </div>
                            </div>

                            <div
                              v-show="this.categories.length == 0"
                              class="categories__select__noData pt-3"
                            >
                              <p>اختار التصنيف:</p>
                              <h6 class="text-center pb-3">
                                لا يوجد تصنيفات حتى الآن
                              </h6>
                            </div>
                          </div>
                          <!-- Add Categories Select -->
                        </div>
                        <div class="col-12">
                          <div class="form-group text-start mt-4">
                            <button
                              type="submit"
                              :disabled="this.isUploadLoading"
                              class="btn add w-100"
                            >
                              <div
                                class="spinner-border text-dark"
                                v-if="this.isUploadLoading"
                                role="status"
                              >
                                <span class="visually-hidden">Loading...</span>
                              </div>

                              <span v-if="!this.isUploadLoading"> أضافة</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <!-- Add Modal End -->

            <div class="dropdown sorting">
              <button
                class="btn add me-2 dropdown-toggle"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                type="button"
              >
                <i class="fas fa-filter ms-1"></i>
                ترتيب {{ this.currentView }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li class="dropdown-item" @click="sortByCreateDate">
                  ترتيب حسب التاريخ
                </li>
                <li class="dropdown-item" @click="sortByName">
                  ترتيب حسب الاسم
                </li>
              </ul>
            </div>
            <!-- Filter -->
            <button
              class="btn me-2 add"
              data-bs-toggle="modal"
              data-bs-target="#filterModal"
            >
              <i class="fas fa-filter ms-1"></i>
              فلتر
            </button>
            <div
              class="modal fade"
              tabindex="-1"
              id="filterModal"
              aria-labelledby="filterModalLabel"
              data-bs-backdrop="static"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <form @submit.prevent="filteredSelectData($event)">
                    <div class="modal-header">
                      <h5 class="modal-title">اعادة تصنيف</h5>
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <!-- Add Categories Select -->
                      <div class="categories__select">
                        <div
                          class="categories__select__data"
                          v-show="this.categories.length > 0"
                        >
                          <div class="form-group">
                            <label>التصنيف</label>
                            <select
                              class="form-select form-control mt-2"
                              aria-label="Default select "
                              @change="onSelectFilterMainCategory($event)"
                            >
                              <option selected disabled value="">
                                اختار التصنيف
                              </option>
                              <option
                                v-for="category in this.Maincategories"
                                :key="category.category_id"
                                :value="category.title"
                              >
                                {{ category.title }}
                              </option>
                            </select>
                          </div>
                          <Transition name="scale" mode="out-in">
                            <div
                              class="form-group"
                              v-if="this.subFilterSelect.length > 0"
                            >
                              <label>تصنيف فرعى</label>
                              <select
                                class="form-select form-control mt-2"
                                aria-label="Default select "
                                id="subCategory"
                                @change="onSelectFilterSubCategory($event)"
                              >
                                <option selected disabled :value="0">
                                  اختار التصنيف
                                </option>
                                <option
                                  v-for="category in this.subFilterSelect"
                                  :key="category.category_id"
                                  :value="category.title"
                                >
                                  {{ category.title }}
                                </option>
                              </select>
                            </div>
                          </Transition>
                          <Transition name="scale" mode="out-in">
                            <div
                              class="form-group"
                              v-if="this.subSubFilterSelect.length > 0"
                            >
                              <label>تصنيف فرعى</label>
                              <select
                                class="form-select form-control mt-2"
                                aria-label="Default select "
                                id="subSubCategory"
                                @change="onSelectFilterSubSubCategory($event)"
                              >
                                <option selected disabled :value="0">
                                  اختار التصنيف
                                </option>
                                <option
                                  v-for="category in this.subSubFilterSelect"
                                  :key="category.category_id"
                                  :value="category.title"
                                >
                                  {{ category.title }}
                                </option>
                              </select>
                            </div>
                          </Transition>

                          <Transition name="scale" mode="out-in">
                            <div
                              class="form-group"
                              v-if="this.subSubSubFilterSelect.length > 0"
                            >
                              <label>تصنيف فرعى</label>
                              <select
                                class="form-select form-control mt-2"
                                aria-label="Default select "
                                id="subSubSubCategory"
                                @change="
                                  onSelectFilterSubSubSubCategory($event)
                                "
                              >
                                <option selected disabled :value="0">
                                  اختار التصنيف
                                </option>
                                <option
                                  v-for="category in this.subSubSubFilterSelect"
                                  :key="category.category_id"
                                  :value="category.title"
                                >
                                  {{ category.title }}
                                </option>
                              </select>
                            </div>
                          </Transition>
                        </div>
                        <div
                          v-show="this.categories.length == 0"
                          class="categories__select__noData pt-3"
                        >
                          <p>اختار التصنيف:</p>
                          <h6 class="text-center pb-3">
                            لا يوجد تصنيفات حتى الآن
                          </h6>
                        </div>
                      </div>
                      <!-- Add Categories Select -->
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn delete"
                        data-bs-dismiss="modal"
                        @click="removeFiltered()"
                      >
                        اعادة تعيين
                      </button>
                      <button type="submit" class="btn add">تنفيذ</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div v-show="!this.isloading" class="infographes-container">
            <div v-show="this.infographes.length > 0" class="infographes">
              <form @submit.prevent="">
                <div class="searching">
                  <div class="form-group">
                    <input
                      type="search"
                      @input="getDocBySeacrh"
                      v-model="searchValue"
                      class="form-control mt-2"
                      placeholder="هل تبحث عن ...."
                      required
                    />
                  </div>
                </div>
              </form>

              <div class="row">
                <div
                  class="col-lg-4 col-md-6 col-12 mb-4"
                  v-for="(infograph, index) in this.infographes"
                  :key="index"
                >
                  <div class="card">
                    <div class="card-body">
                      <div class="card__image">
                        <img class="w-100" :src="infograph.url" alt="" />
                      </div>
                      <div class="card__content">
                        <p class="title">{{ infograph.title }}</p>
                        <p class="size">
                          <span>حجم الصورة: </span>
                          <span class="infograph__size"
                            >{{ (infograph.size / 1024).toFixed(1) }} KB</span
                          >
                        </p>
                      </div>
                    </div>
                    <div class="card-footer">
                      <div class="controls d-flex justify-content-center">
                        <a
                          class="btn view"
                          :href="infograph.url"
                          target="_blank"
                        >
                          <i class="fas fa-folder ms-1"></i>
                          عرض
                        </a>

                        <button
                          class="btn me-2 edit"
                          data-bs-toggle="modal"
                          data-bs-target="#editSelectInfograpgModal"
                          @click="this.getInfograph(infograph)"
                        >
                          <i class="fas fa-edit ms-2"></i>
                          تعديل
                        </button>
                        <div
                          class="modal fade"
                          tabindex="-1"
                          id="editSelectInfograpgModal"
                          aria-labelledby="editSelectInfograpgModalLabel"
                          data-bs-backdrop="static"
                          aria-hidden="true"
                        >
                          <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title">تعديل الصورة</h5>
                                <button
                                  type="button"
                                  class="btn-close"
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                ></button>
                              </div>
                              <div class="modal-body text-end">
                                <form
                                  id="addInfograph"
                                  @submit.prevent="updateInfograph($event)"
                                >
                                  <div class="row">
                                    <div class="col-12">
                                      <div class="form-group">
                                        <label for="infographTitle"
                                          >العنوان</label
                                        >
                                        <input
                                          type="text"
                                          class="form-control mt-2"
                                          id="infographTitle"
                                          placeholder="العنوان"
                                          v-model="updatedInfograph.title"
                                          required
                                        />
                                      </div>
                                    </div>
                                    <div class="col-12">
                                      <div class="form-group">
                                        <label for="infographStatus"
                                          >حالة الصورة</label
                                        >
                                        <select
                                          class="form-select form-control mt-2"
                                          aria-label="Default select "
                                          v-model="updatedInfograph.status"
                                        >
                                          <option selected disabled value="">
                                            اختار حالة الصورة
                                          </option>
                                          <option :value="0">
                                            حفظ داخل مسودة
                                          </option>
                                          <option :value="1">نشر</option>
                                        </select>
                                      </div>
                                    </div>

                                    <div class="col-12">
                                      <div class="form-group files">
                                        <label for="addressTitle"
                                          >الصورة التوضيحية</label
                                        >
                                        <div
                                          class="dragDrop"
                                          id="dragDrop"
                                          @dragover="onDropOver($event)"
                                          @dragleave="onDropLeave($event)"
                                        >
                                          <div
                                            v-if="this.file == null"
                                            class="dragDrop__input"
                                          >
                                            <div class="dragDrop__input__icon">
                                              <i
                                                class="fa fa-upload icon"
                                                aria-hidden="true"
                                              ></i>
                                            </div>
                                          </div>
                                          <div v-else class="dragDrop__file">
                                            <div class="dragDrop__file__icon">
                                              <i
                                                class="fa fa-file icon"
                                                aria-hidden="true"
                                              ></i>
                                            </div>
                                            <div class="dragDrop__file__text">
                                              <span>{{ this.file.name }}</span>
                                            </div>
                                          </div>
                                          <input
                                            type="file"
                                            id="chooseFiles"
                                            placeholder="أضف الملف"
                                            @change="onFileSelect($event)"
                                            accept="image/*"
                                            ref="reviewFileInput"
                                          />
                                        </div>
                                        <!-- Custom Input File -->
                                      </div>
                                    </div>
                                    <div class="col-12">
                                      <!-- Edit Categories Select -->
                                      <div class="categories__select">
                                        <div
                                          class="categories__select__data"
                                          v-show="this.categories.length > 0"
                                        >
                                          <div class="row">
                                            <div class="col-lg-6">
                                              <div class="form-group">
                                                <label>تحديث التصنيف</label>
                                                <select
                                                  class="
                                                    form-select form-control
                                                    mt-2
                                                  "
                                                  aria-label="Default select "
                                                  @change="
                                                    onSelectMainCategory($event)
                                                  "
                                                >
                                                  <option
                                                    selected
                                                    disabled
                                                    :value="0"
                                                  >
                                                    اختار التصنيف
                                                  </option>
                                                  <option
                                                    v-for="category in this
                                                      .Maincategories"
                                                    :key="category.category_id"
                                                    :value="category.title"
                                                  >
                                                    {{ category.title }}
                                                  </option>
                                                </select>
                                              </div>
                                            </div>
                                            <div class="col-lg-6">
                                              <Transition
                                                name="scale"
                                                mode="out-in"
                                              >
                                                <div
                                                  class="form-group"
                                                  v-if="
                                                    this.subSelect.length > 0
                                                  "
                                                >
                                                  <label>تصنيف فرعى</label>
                                                  <select
                                                    class="
                                                      form-select form-control
                                                      mt-2
                                                    "
                                                    id="subCategory"
                                                    aria-label="Default select "
                                                    required
                                                    @change="
                                                      onSelectSubCategory(
                                                        $event
                                                      )
                                                    "
                                                  >
                                                    <option
                                                      selected
                                                      disabled
                                                      value=""
                                                    >
                                                      اختار التصنيف
                                                    </option>
                                                    <option
                                                      v-for="category in this
                                                        .subSelect"
                                                      :key="
                                                        category.category_id
                                                      "
                                                      :value="category.title"
                                                    >
                                                      {{ category.title }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </Transition>
                                            </div>

                                            <div class="col-lg-6">
                                              <Transition
                                                name="scale"
                                                mode="out-in"
                                              >
                                                <div
                                                  class="form-group"
                                                  v-if="
                                                    this.subSubSelect.length > 0
                                                  "
                                                >
                                                  <label>تصنيف فرعى</label>
                                                  <select
                                                    class="
                                                      form-select form-control
                                                      mt-2
                                                    "
                                                    aria-label="Default select "
                                                    @change="
                                                      onSelectSubSubCategory(
                                                        $event
                                                      )
                                                    "
                                                  >
                                                    <option
                                                      selected
                                                      disabled
                                                      value=""
                                                    >
                                                      اختار التصنيف
                                                    </option>
                                                    <option
                                                      v-for="category in this
                                                        .subSubSelect"
                                                      :key="
                                                        category.category_id
                                                      "
                                                      :value="category.title"
                                                    >
                                                      {{ category.title }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </Transition>
                                            </div>

                                            <div class="col-lg-6">
                                              <Transition
                                                name="scale"
                                                mode="out-in"
                                              >
                                                <div
                                                  class="form-group"
                                                  v-if="
                                                    this.subSubSubSelect
                                                      .length > 0
                                                  "
                                                >
                                                  <label>تصنيف فرعى</label>
                                                  <select
                                                    class="
                                                      form-select form-control
                                                      mt-2
                                                    "
                                                    aria-label="Default select "
                                                    @change="
                                                      onSelectSubSubSubCategory(
                                                        $event
                                                      )
                                                    "
                                                  >
                                                    <option
                                                      selected
                                                      disabled
                                                      value=""
                                                    >
                                                      اختار التصنيف
                                                    </option>
                                                    <option
                                                      v-for="category in this
                                                        .subSubSubSelect"
                                                      :key="
                                                        category.category_id
                                                      "
                                                      :value="category.title"
                                                    >
                                                      {{ category.title }}
                                                    </option>
                                                  </select>
                                                </div>
                                              </Transition>
                                            </div>

                                            <div
                                              class="col-lg-6"
                                              v-if="
                                                this.updatedInfograph
                                                  .fullCategoriesInfo != null
                                              "
                                            >
                                              <div class="form-group">
                                                <label>التصنيف الحالى</label>

                                                <div class="categories">
                                                  <ul class="pe-2">
                                                    <li
                                                      v-for="category in this
                                                        .updatedInfograph
                                                        .fullCategoriesInfo"
                                                      :key="
                                                        category.category_id
                                                      "
                                                    >
                                                      - {{ category.title }}
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          v-show="this.categories.length == 0"
                                          class="
                                            categories__select__noData
                                            pt-3
                                          "
                                        >
                                          <p>اختار التصنيف:</p>
                                          <h6 class="text-center pb-3">
                                            لا يوجد تصنيفات حتى الآن
                                          </h6>
                                        </div>
                                      </div>
                                      <!-- Edit Categories Select -->
                                    </div>

                                    <div class="col-12">
                                      <div class="form-group text-start mt-4">
                                        <button
                                          type="submit"
                                          class="btn w-100 add"
                                        >
                                          تعديل
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                        <button
                          class="btn me-2 delete"
                          @click="this.deleteSelectedInfograph(infograph)"
                        >
                          <i class="fas fa-trash-alt ms-2"></i>
                          حذف
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-show="
                (!this.isloading && !this.infographes) ||
                this.infographes.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">لا يوجد صور توضيحية حتى الآن</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
// Vuex
import { mapActions, mapGetters } from "vuex";
// Swal
import Swal from "sweetalert2";
// Firebase Upload Component
import FirebaseUploadingFileVue from "@/components/FirebaseUploadingFile.vue";
// Toast to Show Message
import { useToast, TYPE } from "vue-toastification";
const toast = useToast();
// Delete from firebase Storage
import { deleteFileFromUrl } from "@/firebase/firebase_storage";

export default {
  data() {
    return {
      isUploadLoading: false,
      // Get Categories has Main
      Maincategories: [],
      // Loop for Categories
      selectedCategory: null,
      selectedSubCategory: null,
      selectedSubSubCategory: null,
      selectedSubSubSubCategory: null,

      // Save Result loop Categories
      subSelect: [],
      subSubSelect: [],
      subSubSubSelect: [],
      // Loading
      isloading: false,
      firstLoad: "",
      // Current Page Name
      currentView: "الصور التوضيحية",
      // Update Infograph
      updatedInfograph: {},
      // Infographics Data
      file: null,
      categories: [],
      infographes: [],
      infograph: {
        file_type: 1,
        status: 1,
        title: "",
        size: 0,
        url: "",
        categories: [],
        fullCategoriesInfo: [],
      },
      SelectedInfograph: {},
      // Modal
      searchValue: "",

      // Filter
      selectedFiltrtCategory: null,
      selectedFiltrtSubCategory: null,
      selectedFiltrtSubSubCategory: null,

      subFilterSelect: [],
      subSubFilterSelect: [],
      subSubSubFilterSelect: [],
      filter: [],
    };
  },
  methods: {
    ...mapActions("infographModule", [
      "fetchInfographes",
      "addInfograph",
      "updateInfographById",
      "deleteInfograph",
      "getInfographById",
    ]),

    //-----------------------------------------------
    // Sort
    sortByCreateDate() {
      this.infographes.sort(
        (a, b) => b.created_date.seconds - a.created_date.seconds
      );
    },
    sortByName() {
      this.infographes.sort((a, b) => (a.title < b.title ? -1 : 1));
    },
    //-----------------------------------------------

    //-----------------------------------------------
    // Search
    getDocBySeacrh() {
      setTimeout(() => {
        var re = new RegExp(this.searchValue + ".+$", "i");
        this.infographes = this.getInfographes.filter(
          (item) => item.title.search(re) != -1
        );
      }, 800);
    },
    //-----------------------------------------------
    async getInfograph(infograph) {
      this.updatedInfograph = await this.getInfographById(
        infograph.infograph_id
      );
    },
    //-----------------------------------------------
    // Get Categories
    ///// Get Main Category
    onSelectFilterMainCategory($event) {
      let title = $event.target.value;
      this.selectedFilterCategory = this.categories.filter(
        (item) => item.title === title
      )[0];
      // Reset Choose Sub Category
      this.subFilterSelect = [];
      this.subSubFilterSelect = [];
      this.subSubSubFilterSelect = [];

      this.filter = [];

      // Choose Sub Category
      if (this.selectedFilterCategory.sub_categories.length > 0) {
        this.subFilterSelect.push(
          ...this.selectedFilterCategory.sub_categories
        );
      }
      this.filter.push(this.selectedFilterCategory.category_id);
      document.getElementById("subCategory").value = 0;
    },
    ///// Get Sub Category
    onSelectFilterSubCategory($event) {
      let title = $event.target.value;
      this.selectedFilterSubCategory = this.subFilterSelect.filter(
        (item) => item.title === title
      )[0];

      this.subSubFilterSelect = [];
      this.subSubSubFilterSelect = [];
      this.filter.splice(1, 3);
      if (this.selectedFilterSubCategory.sub_categories.length > 0) {
        this.subSubFilterSelect.push(
          ...this.selectedFilterSubCategory.sub_categories
        );
      }
      this.filter.push(this.selectedFilterSubCategory.category_id);
      document.getElementById("subSubCategory").value = 0;
    },
    ///// Get Sub Sub Category
    onSelectFilterSubSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubSubCategory = this.subSubFilterSelect.filter(
        (item) => item.title === title
      )[0];
      this.subSubSubFilterSelect = [];

      this.filter.splice(2, 1);
      if (this.selectedSubSubCategory.sub_categories.length > 0) {
        this.subSubSubFilterSelect.push(
          ...this.selectedSubSubCategory.sub_categories
        );
      }
      this.filter.push(this.selectedSubSubCategory.category_id);
      document.getElementById("subSubSubCategory").value = 0;
    },
    onSelectFilterSubSubSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubSubSubCategory = this.subSubSubFilterSelect.filter(
        (item) => item.title === title
      )[0];
      this.filter.splice(3, 1);
      this.filter.push(this.selectedSubSubSubCategory.category_id);
      console.log(this.filter);
    },
    //-----------------------------------------------------//
    // Filter
    filteredSelectData(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");

      this.infographes = [];
      this.getInfographes.forEach((infograph) => {
        if (
          this.filter.length == 1 &&
          infograph.categories[0] == this.filter[0]
        ) {
          this.infographes.push(infograph);
        } else if (
          this.filter.length == 2 &&
          infograph.categories[0] == this.filter[0] &&
          infograph.categories[1] == this.filter[1]
        ) {
          this.infographes.push(infograph);
        } else if (
          this.filter.length == 3 &&
          infograph.categories[0] == this.filter[0] &&
          infograph.categories[1] == this.filter[1] &&
          infograph.categories[2] == this.filter[2]
        ) {
          this.infographes.push(infograph);
        } else if (
          this.filter.length == 4 &&
          infograph.categories[0] == this.filter[0] &&
          infograph.categories[1] == this.filter[1] &&
          infograph.categories[2] == this.filter[2] &&
          infograph.categories[3] == this.filter[3]
        ) {
          this.infographes.push(infograph);
        }
      });
      closeButton.click();
    },

    removeFiltered() {
      this.infographes = this.getInfographes;
      // this.filter = "";
      this.filter = [];
    },
    //-----------------------------------------------

    // Vuex Methods
    ///// Add Infograph
    async addNewInfograph(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      this.isUploadLoading = true;
      if (this.file !== null) {
        this.infograph.size = this.file.size;

        const content = {
          // Your component or JSX template
          component: FirebaseUploadingFileVue,

          // Props are just regular props, but these won't be reactive
          props: {
            title: "يتم رفع الصورة التوضيحية الان",
            file: this.file,
            collection: "IMAGEs",
            onFinished: (url) => {
              this.infograph.url = url ?? "";
              toast.dismiss(toastId);
              this.addInfograph(this.infograph);
              closeButton.click();
              this.clearAndShowSuccess();
              this.isUploadLoading = false;
            },
          },
        };

        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
          toastClassName: "my-custom-toast-class",
        });
      }
    },
    ///// Update Infograph
    async updateInfograph(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");

      console.log(closeButton);
      if (this.file !== null) {
        deleteFileFromUrl(this.updatedInfograph.url);
        const content = {
          // Your component or JSX template
          component: FirebaseUploadingFileVue,

          // Props are just regular props, but these won't be reactive
          props: {
            title: "يتم رفع الصورة التوضيحية الان",
            file: this.file,
            collection: "IMAGEs",
            onFinished: (url) => {
              this.updatedInfograph.url = url ?? "";
              this.updatedInfograph.size = this.file.size;

              toast.dismiss(toastId);
              this.updateInfographById(this.updatedInfograph);
              closeButton.click();
              this.clearAndShowSuccess();
            },
          },
        };

        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
        });
      } else {
        await this.updateInfographById(this.updatedInfograph);
        closeButton.click();
        this.clearAndShowSuccess();
        //this.fetchInfographes();
      }
    },
    ///// Delete Infograph
    deleteSelectedInfograph(infograph) {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذه الصورة التوضيحية؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف الصورة التوضيحية بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteInfograph(infograph.infograph_id);
          deleteFileFromUrl(infograph.url);
        }
      });
    },
    //-----------------------------------------------------//
    // Get Categories
    ///// Get Main Category
    onSelectMainCategory($event) {
      let title = $event.target.value;
      this.selectedCategory = this.categories.filter(
        (item) => item.title === title
      )[0];
      // Reset Choose Sub Category
      this.subSelect = [];
      this.subSubSelect = [];
      this.subSubSubSelect = [];
      this.infograph.categories = [];
      this.infograph.fullCategoriesInfo = [];
      this.updatedInfograph.fullCategoriesInfo = [];
      this.updatedInfograph.categories = [];

      // Choose Sub Category
      if (this.selectedCategory.sub_categories.length > 0) {
        this.subSelect.push(...this.selectedCategory.sub_categories);
      }
      this.infograph.categories.push(this.selectedCategory.category_id);
      this.infograph.fullCategoriesInfo.push(this.selectedCategory);
      this.updatedInfograph.fullCategoriesInfo.push(this.selectedCategory);
      this.updatedInfograph.categories.push(this.selectedCategory.category_id);
      console.log(this.selectedCategory);
    },
    ///// Get Sub Category
    onSelectSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubCategory = this.subSelect.filter(
        (item) => item.title === title
      )[0];

      this.subSubSelect = [];
      this.subSubSubSelect = [];

      this.infograph.categories.splice(1, 1);
      this.infograph.fullCategoriesInfo.splice(1, 1);
      this.updatedInfograph.fullCategoriesInfo.splice(1, 1);
      this.updatedInfograph.categories.splice(1, 1);
      if (this.selectedSubCategory.sub_categories.length > 0) {
        this.subSubSelect.push(...this.selectedSubCategory.sub_categories);
      }
      this.infograph.categories.push(this.selectedSubCategory.category_id);
      this.infograph.fullCategoriesInfo.push(this.selectedSubCategory);
      this.updatedInfograph.fullCategoriesInfo.push(this.selectedSubCategory);
      this.updatedInfograph.categories.push(
        this.selectedSubCategory.category_id
      );
      console.log(this.selectedSubCategory);
    },
    ///// Get Sub Sub Category
    onSelectSubSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubSubCategory = this.subSubSelect.filter(
        (item) => item.title === title
      )[0];
      this.subSubSubSelect = [];

      this.infograph.categories.splice(2, 1);
      this.infograph.fullCategoriesInfo.splice(2, 1);
      this.updatedInfograph.fullCategoriesInfo.splice(2, 1);
      this.updatedInfograph.categories.splice(2, 1);
      if (this.selectedSubSubCategory.sub_categories.length > 0) {
        this.subSubSubSelect.push(
          ...this.selectedSubSubCategory.sub_categories
        );
      }
      this.infograph.categories.push(this.selectedSubSubCategory.category_id);
      this.infograph.fullCategoriesInfo.push(this.selectedSubSubCategory);
      this.updatedInfograph.fullCategoriesInfo.push(
        this.selectedSubSubCategory
      );
      this.updatedInfograph.categories.push(
        this.selectedSubSubCategory.category_id
      );
      console.log(this.selectedSubSubCategory);
    },

    onSelectSubSubSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubSubSubCategory = this.subSubSubSelect.filter(
        (item) => item.title === title
      )[0];
      this.infograph.categories.splice(3, 1);
      this.infograph.fullCategoriesInfo.splice(3, 1);
      this.updatedInfograph.fullCategoriesInfo.splice(3, 1);
      this.updatedInfograph.categories.splice(3, 1);
      this.infograph.categories.push(
        this.selectedSubSubSubCategory.category_id
      );
      this.infograph.fullCategoriesInfo.push(this.selectedSubSubSubCategory);
      this.updatedInfograph.fullCategoriesInfo.push(
        this.selectedSubSubSubCategory
      );
      this.updatedInfograph.categories.push(
        this.selectedSubSubSubCategory.category_id
      );
      console.log(this.selectedSubSubSubCategory);
    },
    //-----------------------------------------------------//
    // clear Data when close modal
    clearData() {
      this.file = null;
      // let clearButton = document.querySelector(".clearButton");
      // clearButton.click();
      // Remove input Hover
      document.getElementById("chooseFiles").value = "";
      document
        .getElementsByClassName("dragDrop")[0]
        .classList.remove("drop_zone");
      document.getElementById("categorySelect").value = 0;
      this.subSelect = [];
      this.subSubSelect = [];
      this.selectedCategory = [];
      this.selectedSubCategory = [];
      this.infograph = {
        file_type: 1,
        url: "",
        status: 1,
        categories: [],
      };
    },
    // On Upload Image
    seccussAdd() {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: "تم إضافة الصورة التوضيحية بنجاح",
      });
    },
    // Handle Add Infograph
    clearAndShowSuccess() {
      this.seccussAdd();
      this.clearData();
    },
    //-----------------------------------------------------//
    ///// Custom Input File
    // Drop Over Elemet area
    onDropOver($event) {
      let el = $event.currentTarget;
      el.classList.add("drop_zone");
    },
    // Drop Leave Elemet area
    onDropLeave($event) {
      let el = $event.currentTarget;
      el.classList.remove("drop_zone");
    },
    // When Select File
    onFileSelect(e) {
      this.file = e.target.files[0] || e.dataTransfer;
      this.review.size = this.file.size;
      this.review.name = this.file.name;
      // this.lessonImage = this.file;
    },
    //-----------------------------------------------------//
  },
  async created() {
    if (this.isFirstLoad) {
      await this.fetchInfographes();
    }

    // get Main Categories
    this.Maincategories = this.getCategories.filter(
      (item) => item.main_category === true
    );
  },
  computed: {
    ...mapGetters("categoriesModule", ["getCategories"]),
    ...mapGetters("infographModule", [
      "getInfographes",
      "isLoading",
      "isFirstLoad",
    ]),

    //-----------------------------------------------------//
    // Get Main Categories
  },
  mounted() {
    this.infographes = this.getInfographes;
    this.categories = this.getCategories;
    this.isloading = this.isLoading;
    this.firstLoad = this.isFirstLoad;
    document.getElementById("categorySelect").value = 0;
  },
  watch: {
    getInfographes() {
      this.infographes = this.getInfographes;
    },
    getCategories() {
      this.categories = this.getCategories;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
    isFirstLoad() {
      this.firstLoad = this.isFirstLoad;
    },
  },
};
</script>
